import { render, staticRenderFns } from "./Netting.vue?vue&type=template&id=706e186c&"
import script from "./Netting.vue?vue&type=script&lang=ts&"
export * from "./Netting.vue?vue&type=script&lang=ts&"
import style0 from "./Netting.vue?vue&type=style&index=0&id=706e186c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports